// @ts-nocheck

import { formatForLog } from 'app/shared/utils/errors';
import oneTrustUtils from 'app/shared/utils/oneTrustUtils';
const logger = log.child('utils/analytics/optimizely');

const optimizelyUtils = {
    hasInitiated: false,
    initiate: () => {
        oneTrustUtils
            .waitForOptanon()
            .then(() => {
                if (!optimizelyUtils.hasInitiated) {
                    optimizelyUtils.hasInitiated = true;
                    window.Optanon.InsertScript(
                        '//cdn.optimizely.com/js/1719570453.js',
                        'head',
                        null,
                        null,
                        3 // functional cookie
                    );
                }
            })
            .catch((err) => {
                logger.error(formatForLog(err), 'Optimizely: initializing optimizely script');
            });
    },
    track: () => {
        window.optimizely = window.optimizely || [];

        // optimizely object matches that of rental-manager-web
        window.optimizely.push({
            type: 'event',
            eventName: 'ltleases_cta',
            tags: {
                revenue: 0,
                value: 0.0
            }
        });
    }
};

export default optimizelyUtils;
